import { render, staticRenderFns } from "./PopupPrincipal.vue?vue&type=template&id=4a02611e&scoped=true"
import script from "./PopupPrincipal.vue?vue&type=script&lang=js"
export * from "./PopupPrincipal.vue?vue&type=script&lang=js"
import style0 from "./PopupPrincipal.vue?vue&type=style&index=0&id=4a02611e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a02611e",
  null
  
)

export default component.exports